module.exports = __webpack_public_path__ + "img/mission.db4f117a.jpg";